import { render, staticRenderFns } from "./DraftItem.vue?vue&type=template&id=38d4c907&scoped=true&"
import script from "./DraftItem.vue?vue&type=script&lang=js&"
export * from "./DraftItem.vue?vue&type=script&lang=js&"
import style0 from "./DraftItem.vue?vue&type=style&index=0&id=38d4c907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4c907",
  null
  
)

export default component.exports